import React, { useState, useRef, useEffect } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import './Navbar.css';

function Navbar({ user, onLogout }) {
  const [legalOpen, setLegalOpen] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const legalRef = useRef(null);
  const navigate = useNavigate();
  const location = useLocation();

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (legalRef.current && !legalRef.current.contains(event.target)) {
        setLegalOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  // Close mobile menu on route change
  useEffect(() => {
    setMobileMenuOpen(false);
  }, [location]);


  return (
    <nav className="navbar">
      <div className="navbar-content">
        {/* Logo */}
        <Link to="/" className="navbar-logo">
          Mindmark
        </Link>

        {/* Desktop Navigation */}
        <div className="navbar-links">
          <Link to="/how-it-works" className="navbar-link">
            How It Works
          </Link>
          <Link to="/pricing" className="navbar-link">
            Pricing
          </Link>
          <Link to="/faq" className="navbar-link">
            FAQ
          </Link>

          {/* Legal Dropdown */}
          <div
            className="navbar-dropdown"
            ref={legalRef}
            onMouseEnter={() => setLegalOpen(true)}
            onMouseLeave={() => setLegalOpen(false)}
          >
            <Link
              to="/legal"
              className="navbar-link dropdown-trigger"
            >
              Legal
              <svg
                className={`dropdown-arrow ${legalOpen ? 'open' : ''}`}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                width="16"
                height="16"
              >
                <polyline points="6 9 12 15 18 9"/>
              </svg>
            </Link>

            {legalOpen && (
              <div className="dropdown-menu">
                <Link to="/terms" className="dropdown-item">
                  Terms of Use
                </Link>
                <Link to="/privacy" className="dropdown-item">
                  Privacy Policy
                </Link>
                <Link to="/disclaimer" className="dropdown-item">
                  Disclaimer
                </Link>
              </div>
            )}
          </div>
        </div>

        {/* Auth Buttons */}
        <div className="navbar-auth">
          {user ? (
            <>
              <Link to="/checker" className="btn-primary">
                Checker
              </Link>
              <button onClick={() => { onLogout && onLogout(); }} className="btn-ghost">
                Log out
              </button>
            </>
          ) : (
            <>
              <Link to="/login" className="btn-ghost">
                Log in
              </Link>
              <Link to="/signup" className="btn-primary">
                Sign up for free
              </Link>
            </>
          )}
        </div>

        {/* Mobile Menu Button */}
        <button
          className="mobile-menu-btn"
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          aria-label="Toggle menu"
        >
          {mobileMenuOpen ? (
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="24" height="24">
              <line x1="18" y1="6" x2="6" y2="18"/>
              <line x1="6" y1="6" x2="18" y2="18"/>
            </svg>
          ) : (
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="24" height="24">
              <line x1="3" y1="12" x2="21" y2="12"/>
              <line x1="3" y1="6" x2="21" y2="6"/>
              <line x1="3" y1="18" x2="21" y2="18"/>
            </svg>
          )}
        </button>
      </div>

      {/* Mobile Menu */}
      {mobileMenuOpen && (
        <div className="mobile-menu">
          <Link to="/how-it-works" className="mobile-menu-link">How It Works</Link>
          <Link to="/pricing" className="mobile-menu-link">Pricing</Link>
          <Link to="/faq" className="mobile-menu-link">FAQ</Link>
          <Link to="/legal" className="mobile-menu-link">Legal</Link>
          <Link to="/terms" className="mobile-menu-link mobile-menu-sub">Terms of Use</Link>
          <Link to="/privacy" className="mobile-menu-link mobile-menu-sub">Privacy Policy</Link>
          <Link to="/disclaimer" className="mobile-menu-link mobile-menu-sub">Disclaimer</Link>

          <div className="mobile-menu-divider" />

          {user ? (
            <>
              <Link to="/checker" className="mobile-menu-link">Checker</Link>
              <button onClick={() => { onLogout && onLogout(); }} className="mobile-menu-link">Log out</button>
            </>
          ) : (
            <>
              <Link to="/login" className="mobile-menu-link">Log in</Link>
              <Link to="/signup" className="mobile-menu-link accent">Sign up for free</Link>
            </>
          )}
        </div>
      )}
    </nav>
  );
}

export default Navbar;
